import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import { KYMW0001Component } from './kymw0001.component';
import { GetMarkCodeListService } from './api-services/get-mark-code-list.service';

/**
 * マーク選択画面 モジュール設定クラス
 *
 * @export KYMW0001Module
 * @class KYMW0001Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjInputModule,
  ],
  declarations: [KYMW0001Component],
  providers: [
    GetMarkCodeListService,
  ],
})
export class KYMW0001Module {}
